export enum ClientCheckinEventType
{
    CheckOut = -1,
    CheckIn = 1
}

export enum ClientCheckInAccessStatus
{
    Denied = 0,
    Granted = 1
}

export enum GuestPassStatus
{
    Booked = 1,
    Attended = 2,
    NoShow = 3,
    Cancelled = 4
}


export enum ClientReferralStatus   {
    Expired = 0,
    Active = 1,
    Successful = 2
}

export enum ClientRelation
{
    None = 0,   
    Parent = 11,
    Child = 12, 
    Spouse = 13,
    Sibling = 14,
    Friend = 15,
    Partner = 16,
    Colleague = 17,
    Other = 18
}

export enum ReferralStatus
{
    Expired = 0,
    Active = 1,
    Successful = 2
}

export enum ExternalProviderCategory {
  ClassPass = 1,
  FitPass = 2,
}

export enum ExternalProviderType {
  ClassPassId = 1,
  FitPassId = 2,
}
